import React from "react";
import { StldCardTableGrupoOptions } from "../../styled-components/StyledCardTableGrupoOptions.style";
import { IconMenuDotsV } from "../../svg";
import Flex from '@react-css/flex';
import { formatDecimalToTimeHHMM } from '../../utils/timeFormatUtil';

export const CardTableGrupoOptions = (props) => {
    const {
        item,
        openNovoGrupoAtividadeModal,
        openGrupoAtividadeCancelModal,
        openNotifyGrupoModal,
        index,
        openNotifyGrupoHistoricoModal,
        canEdit
    } = props;

    const getCardId = (id) => {
        let cardId = document.getElementById(id);

        if (cardId.getAttribute('class', 'card-menu-hide') === 'card-menu-hide') {
            cardId.removeAttribute('class', 'card-menu-hide');
            cardId.setAttribute('class', 'card-menu-show');
        }
        else {
            cardId.removeAttribute('class', 'card-menu-show');
            cardId.setAttribute('class', 'card-menu-hide');
        }
    };


    const formateTime = (value) => {
        if (!value) {
            return '0';
        }

        const parts = value.toString().split(".");

        if (parts.length === 1) {
            return Math.round(parseInt(parts[0], 10), 2);
        }


        let rst = parseInt(parts[0], 10) + (parseInt(parts[1], 10) / 60);
        return Math.round((rst + Number.EPSILON) * 100) / 100;

    };


    const formatCurrency = (value) => {
        if (!value) {
            return 'R$ 0,00';
        }

        return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 });
    };




    return (
        <StldCardTableGrupoOptions key={index}>
            <Flex onMouseOut={() => getCardId(index)} onMouseOver={() => getCardId(index)}>
                <Flex.Item className="card-menu-title"></Flex.Item>
                <Flex.Item className="card-menu-title-left">
                    <ul id={index} className="card-menu-hide">
                        {
                            (item?.actions?.notificado || item?.actions?.editar && canEdit) && item?.Value[0]?.status != 'Cancelado' && (<li className="menu-card" onClick={() => openNovoGrupoAtividadeModal(item)}>Editar</li>)
                        }
                        {
                            item?.actions?.cancelar && canEdit && item?.Value[0]?.status != 'Cancelado' && (<li className="menu-card" onClick={() => openGrupoAtividadeCancelModal(item)}>Cancelar</li>)
                        }
                        {
                            item?.actions?.notificar && item?.Value[0]?.status != 'Cancelado' && (<li className="menu-card" onClick={() => openNotifyGrupoModal(item)}>Notificar</li>)
                        }
                        {
                            item?.actions?.notificar && item?.Value[0]?.status != 'Cancelado' && (<li className="menu-card" onClick={() => openNotifyGrupoHistoricoModal(item)}>Notificações</li>)
                        }
                    </ul>
                </Flex.Item>
            </Flex>
            <div className="card-align" id={props.id}>
                <Flex className="flex-column-float-right">
                    <Flex.Item className="flex-column-title-right">
                        <span>
                            <button className="button-icon" onMouseOut={() => getCardId(index)} onMouseOver={() => getCardId(index)}><IconMenuDotsV /></button>
                        </span>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <Flex.Item className="flex-column-left">
                        <span className="details">Período: {item.Value[0].periodoInicio} - {item.Value[0].periodoFim}</span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right">
                        {(() => {
                            if (item.Value[0].status === "Ativo") {
                                return (
                                    <span className="btn btn-success">{item.Value[0].status}</span>
                                )
                            } else if (item.Value[0].status === "Cancelado") {
                                return (
                                    <span className="btn btn-danger">{item.Value[0].status}</span>
                                )
                            } else {
                                return (
                                    <span className="btn btn-warning">{item.Value[0].status}</span>
                                )
                            }
                        })()}
                    </Flex.Item>
                </Flex>

                <Flex>
                    <Flex.Item className="flex-column-left">
                        <span className="details"> Quantidade </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-left">
                        <span className="details"> Valor Hora </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-left">
                        <span className="details"> Horas </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-left">
                        <span className="details"> Total </span>
                    </Flex.Item>
                </Flex>

                {item.Value.map((atividade, index) => {
                    return (
                        <div style={{ borderBottom: "1px solid" }} key={index}>
                            <Flex.Item className="flex-column-left">
                                <p className="details sub-details text-max-50" style={{ margin: "0" }} title={atividade.atividade}>{atividade.atividade}</p>
                                <p className="details description sub-details text-max-50" style={{ margin: "0" }} title={atividade.descricao}>{atividade.descricao}</p>
                            </Flex.Item>
                            <Flex>
                                <Flex.Item className="flex-column-left">
                                    <span className="details"> {[3, 4].includes(atividade.idGrupoAtividade) ? '-' : atividade.horasExecutadas} </span>
                                </Flex.Item>
                                <Flex.Item className="flex-column-left">
                                    <span className="details">{formatCurrency(atividade.valorHoraBase)}</span>
                                </Flex.Item>
                                <Flex.Item className="flex-column-left">
                                    <span className="details"> {[3, 4].includes(atividade.idGrupoAtividade) ? formatDecimalToTimeHHMM(atividade.horasExecutadas) : atividade.horaCoeficiente} </span>
                                </Flex.Item>
                                <Flex.Item className="flex-column-left">
                                    <span className="details">{formatCurrency(atividade.totalValorFaturado)}</span>
                                </Flex.Item>
                            </Flex>
                        </div>
                    )
                })}

                <br />
                <Flex style={{ height: "5%" }}>
                    <Flex.Item className="flex-column-center">
                        <span className="name-info">&nbsp;{item.perito.nome}&nbsp;</span>
                    </Flex.Item>
                </Flex>

            </div>
        </StldCardTableGrupoOptions>
    );
};
